import type { ReactNode } from 'react';
import type { Variant } from '../types';

export interface BadgeProps {
  variant?: Variant;
  /** Limitless soft style: tinted background + colored text (`bg-*-opacity-20 text-*`). */
  soft?: boolean;
  pill?: boolean;
  children?: ReactNode;
  className?: string;
}

export function Badge({ variant = 'primary', soft = false, pill = false, children, className = '' }: BadgeProps) {
  const color = soft ? `bg-${variant} bg-opacity-20 text-${variant}` : `bg-${variant}`;
  const classes = ['badge', color, pill ? 'rounded-pill' : '', className].filter(Boolean).join(' ');
  return <span className={classes}>{children}</span>;
}
